export const franceUniversities = {
  "sorbonne-university": {
    slug: "sorbonne-university", country: "france",
    name: "Sorbonne University", shortName: "Sorbonne", flag: "🇫🇷",
    city: "Paris", founded: 1257, qsRank: "#59 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?q=80&w=900&auto=format&fit=crop",
    overview: "One of Europe’s most historic universities, renowned for humanities, sciences, medicine, and research excellence.",
    tuition: { domestic: "€250–€4,000/yr", international: "€3,000–€8,000/yr" },
    living: "€1,000–€1,600/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Computer Science", duration: "2 years", language: "English" },
      { name: "MSc Physics", duration: "2 years", language: "English" },
      { name: "MBA / Management", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€38,000–€62,000", topEmployers: ["L'Oréal", "Capgemini", "BNP Paribas"] },
    intakes: ["September", "January"], istpStudents: 18,
  },

  "psl-university": {
    slug: "psl-university", country: "france",
    name: "PSL University", shortName: "PSL", flag: "🇫🇷",
    city: "Paris", founded: 2010, qsRank: "#24 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1431274172761-fca41d930114?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1522093007474-d86e9bf7ba6f?q=80&w=900&auto=format&fit=crop",
    overview: "Elite French institution formed from top Grandes Écoles and research schools.",
    tuition: { domestic: "€500–€5,000/yr", international: "€4,000–€12,000/yr" },
    living: "€1,100–€1,700/mo", ielts: "6.5+", gre: "Program-dependent",
    topCourses: [
      { name: "MSc Data Science", duration: "2 years", language: "English" },
      { name: "MSc Economics", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "€45,000–€70,000", topEmployers: ["McKinsey", "BCG", "Google"] },
    intakes: ["September"], istpStudents: 10,
  },

  "hec-paris": {
    slug: "hec-paris", country: "france",
    name: "HEC Paris", shortName: "HEC", flag: "🇫🇷",
    city: "Jouy-en-Josas", founded: 1881, qsRank: "#1 Europe MBA Reputation",
    heroImg: "https://images.unsplash.com/photo-1515169067868-5387ec356754?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "France’s premier business school known globally for MBA, MiM, finance, and consulting careers.",
    tuition: { domestic: "€20,000+/yr", international: "€25,000–€80,000/yr" },
    living: "€1,100–€1,800/mo", ielts: "7.0+", gre: "Often Required",
    topCourses: [
      { name: "MBA", duration: "16 months", language: "English" },
      { name: "Master in Management", duration: "2 years", language: "English" },
      { name: "MSc Finance", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "96%", avgSalary: "€65,000–€120,000", topEmployers: ["Goldman Sachs", "BCG", "LVMH"] },
    intakes: ["September", "January"], istpStudents: 7,
  },

  "insead": {
    slug: "insead", country: "france",
    name: "INSEAD", shortName: "INSEAD", flag: "🇫🇷",
    city: "Fontainebleau", founded: 1957, qsRank: "#Global Top MBA",
    heroImg: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=900&auto=format&fit=crop",
    overview: "One of the world’s leading graduate business schools with elite MBA outcomes.",
    tuition: { domestic: "€40,000+/yr", international: "€50,000–€100,000/yr" },
    living: "€1,200–€2,000/mo", ielts: "7.0+", gre: "Required for many programmes",
    topCourses: [
      { name: "MBA", duration: "10 months", language: "English" },
      { name: "Executive MBA", duration: "18 months", language: "English" },
    ],
    placementStats: { rate: "97%", avgSalary: "€90,000–€150,000", topEmployers: ["Amazon", "McKinsey", "Bain"] },
    intakes: ["January", "August"], istpStudents: 5,
  },

  "ecole-polytechnique": {
    slug: "ecole-polytechnique", country: "france",
    name: "École Polytechnique", shortName: "X", flag: "🇫🇷",
    city: "Palaiseau", founded: 1794, qsRank: "#46 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=900&auto=format&fit=crop",
    overview: "Top engineering Grande École famous for mathematics, AI, engineering, and research.",
    tuition: { domestic: "€1,000–€6,000/yr", international: "€10,000–€18,000/yr" },
    living: "€900–€1,400/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "2 years", language: "English" },
      { name: "MSc Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "95%", avgSalary: "€50,000–€85,000", topEmployers: ["Airbus", "Thales", "Google"] },
    intakes: ["September"], istpStudents: 8,
  },

  "university-paris-saclay": {
    slug: "university-paris-saclay", country: "france",
    name: "University of Paris-Saclay", shortName: "Paris-Saclay", flag: "🇫🇷",
    city: "Paris Region", founded: 2014, qsRank: "#71 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=900&auto=format&fit=crop",

    overview: "Strong in science, engineering, mathematics, and innovation ecosystems.",
    tuition: { domestic: "€500–€4,000/yr", international: "€4,000–€10,000/yr" },
    living: "€900–€1,500/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc Data Science", duration: "2 years", language: "English" }],
    placementStats: { rate: "91%", avgSalary: "€40,000–€65,000", topEmployers: ["EDF", "Capgemini"] },
    intakes: ["September"], istpStudents: 6,
  },

  "grenoble-alpes-university": {
    slug: "grenoble-alpes-university", country: "france",
    name: "Grenoble Alpes University", shortName: "UGA", flag: "🇫🇷",
    city: "Grenoble", founded: 1339, qsRank: "#294 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?q=80&w=900&auto=format&fit=crop",
    overview: "Known for computer science, engineering, physics, and alpine innovation cluster.",
    tuition: { domestic: "€500–€4,000/yr", international: "€4,000–€8,000/yr" },
    living: "€800–€1,200/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Computer Science", duration: "2 years", language: "English" }],
    placementStats: { rate: "89%", avgSalary: "€36,000–€55,000", topEmployers: ["STMicroelectronics", "Schneider"] },
    intakes: ["September"], istpStudents: 4,
  },

  "lyon-1-university": {
    slug: "lyon-1-university", country: "france",
    name: "Claude Bernard University Lyon 1", shortName: "Lyon 1", flag: "🇫🇷",
    city: "Lyon", founded: 1971, qsRank: "#401+ QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Popular for life sciences, health sciences, and engineering.",
    tuition: { domestic: "€500–€4,000/yr", international: "€4,000–€8,000/yr" },
    living: "€800–€1,250/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Biotechnology", duration: "2 years", language: "English" }],
    placementStats: { rate: "88%", avgSalary: "€35,000–€52,000", topEmployers: ["Sanofi", "BioMérieux"] },
    intakes: ["September"], istpStudents: 3,
  },

  "emlyon-business-school": {
    slug: "emlyon-business-school", country: "france",
    name: "emlyon business school", shortName: "emlyon", flag: "🇫🇷",
    city: "Lyon", founded: 1872, qsRank: "#Top Business School",
    heroImg:
      "https://images.unsplash.com/photo-1497366412874-3415097a27e7?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=900&auto=format&fit=crop",
    overview: "Highly reputed French business school for management, marketing, and entrepreneurship.",
    tuition: { domestic: "€15,000+/yr", international: "€18,000–€35,000/yr" },
    living: "€850–€1,300/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc Management", duration: "2 years", language: "English" }],
    placementStats: { rate: "94%", avgSalary: "€48,000–€82,000", topEmployers: ["Deloitte", "EY", "L'Oréal"] },
    intakes: ["September", "January"], istpStudents: 5,
  },

  "skema-business-school": {
    slug: "skema-business-school", country: "france",
    name: "SKEMA Business School", shortName: "SKEMA", flag: "🇫🇷",
    city: "Nice / Paris", founded: 2009, qsRank: "#Top Business School",
    heroImg:
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",
    overview: "Internationally focused business school popular with Indian students.",
    tuition: { domestic: "€12,000+/yr", international: "€15,000–€28,000/yr" },
    living: "€850–€1,500/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc International Business", duration: "1 year", language: "English" }],
    placementStats: { rate: "92%", avgSalary: "€42,000–€70,000", topEmployers: ["Accenture", "PwC", "Amazon"] },
    intakes: ["September", "January"], istpStudents: 6,
  },
};